import React, {useState, useEffect, useContext} from 'react';
import { parse, startOfWeek, endOfWeek, getMonth, getYear, startOfYear, endOfYear, startOfMonth, endOfMonth } from 'date-fns';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { LabelText } from '../../components/Language/LabelText';
import PrevNextDate from '../../components/UI/Date/PrevNextDate';
import HeaderTitle from '../../hoc/HeaderTitle';
import WeeklyDatePicker from './WeeklyDatePicker';
import './calendarrevenue.css';
import { RevenueCalendarContext } from '../context/RevenueCalendarProvider';

export default function CalendarWeeklyRevenue(props) {
    const sDate = props.weeklyStartDate && parse(props.weeklyStartDate, "dd/MM/yyyy", new Date()); 
    const [startDate, setStartDate] = useState(sDate); 
    const eDate = props.weeklyEndDate && parse(props.weeklyEndDate, "dd/MM/yyyy", new Date()); 
    const [endDate, setEndDate] = useState(eDate);
    const { setRawDate } = useContext(RevenueCalendarContext);

    const dateChangeHandler = (changedDate) => {  
        if (changedDate) {
            let stDate = startOfWeek(changedDate, {weekStartsOn: 1});  
            let enDate = endOfWeek(changedDate, {weekStartsOn: 1});  
            const selectedDateMonth = getMonth(changedDate);
            const selectedDateYear = getYear(changedDate);

            if(stDate && enDate) {
                if(selectedDateYear === getYear(stDate) && selectedDateYear === getYear(enDate)) {
                    if (selectedDateMonth > getMonth(stDate)) {
                        stDate=startOfMonth(changedDate);
                    } else if (selectedDateMonth < getMonth(stDate)) {
                        stDate=endOfMonth(changedDate)
                    } else if (selectedDateMonth > getMonth(enDate)) {
                        enDate=startOfMonth(changedDate);
                    } else if (selectedDateMonth < getMonth(enDate)) {
                        enDate=endOfMonth(changedDate)
                    }
                } else if (selectedDateYear > getYear(stDate)) {
                    stDate=startOfYear(changedDate);
                } else if (selectedDateYear < getYear(stDate)) {
                    stDate=endOfYear(changedDate);
                } else if (selectedDateYear > getYear(enDate)) {
                    enDate=startOfYear(changedDate);
                } else if (selectedDateYear < getYear(enDate)) {
                    enDate=endOfYear(changedDate);
                }

                setStartDate(stDate);
                setEndDate(enDate);
                setRawDate();

                props.onDateChange(stDate, startDate, enDate, endDate);
            }
        } 
    }

    useEffect(() => {
        setStartDate(parse(props.weeklyStartDate, "dd/MM/yyyy", new Date()));
        setEndDate((parse(props.weeklyEndDate, "dd/MM/yyyy", new Date())));
    }, [props.isDateChanged]);

    const BottomContentHeaderTitle = styled.div`
    line-height: 2vh;
    padding: 0.2vw 0 0.1vw 1.5vw;
    text-align: left;
    font-size: 1.1vw;
    color: #fff;
    `;

    const BottomContentDate = styled.div`
    text-align: right;
    color: #fff;
    font-size: 1.1vw;
    width: 5vw;
    padding: 0.2vw 1vw 0.3vw 0.5vw;
    margin-top: 0.5vw;
    line-height: 3vh;
    `;

    return (
        <Container className="calendar-revenue-container">
            <Row className="calendar-revenue-row">
                <HeaderTitle>
                    <BottomContentHeaderTitle>
                        <LabelText tid="calendar_revenue" />
                    </BottomContentHeaderTitle>
                </HeaderTitle>
            </Row>
            <Row className="weekly-calendar-revenue-row" style={{marginTop: "-0.25vw"}}>
                <Col className="calendar-revenue-col">
                    <BottomContentDate>
                        <LabelText tid="From" />
                    </BottomContentDate>
                </Col>
                <Col className="calendar-revenue-col-calendar-textbox">
                    {
                        props.weeklyStartDate ? <WeeklyDatePicker tabIndex={0}
                            strictParsing={true}
                            dateFormat="dd/MM/yyyy"
                            enableTabLoop={false}
                            showPopperArrow={false}
                            selectedDate={startDate}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange={false}
                            showMonthDropdown={false} 
                            showYearDropdown={false} 
                            dateChangeHandler={modifiedDate => dateChangeHandler(modifiedDate)}
                            minDate={props.minDate} 
                            maxDate={props.maxDate} 
                            statusWiseRevenueDates={props.statusWiseRevenueDates}
                        /> : null
                    }
                </Col>
                <Col className="calendar-revenue-col-prev-next-date">
                    {
                        props.weeklyStartDate ? <PrevNextDate className="date-arrow-container"
                                                dateChangeHandler={(e) => dateChangeHandler(e)}
                                                revenueDate={startDate}
                                                isWeekly={true}
                                                minDate ={props.minDate} maxDate={props.maxDate} />
                                            : null
                    }
                </Col>
            </Row>
            <Row className="weekly-calendar-revenue-row" style={{marginTop: "-1.1vw"}}>
                <Col className="calendar-revenue-col">
                    <BottomContentDate>
                        <LabelText tid="Untill" />
                    </BottomContentDate>
                </Col>
                <Col className="calendar-revenue-col-calendar-textbox">
                    {
                        props.weeklyEndDate ? <WeeklyDatePicker className="form-control form-control-sm"
                            tabIndex={0}
                            dateChangeHandler={modifiedDate => dateChangeHandler(modifiedDate)}
                            strictParsing={true}
                            dateFormat="dd/MM/yyyy"
                            selectedDate={endDate} 
                            startDate={startDate}
                            endDate={endDate}
                            showPopperArrow={false}
                            enableTabLoop={false}
                            selectsRange={false}
                            showMonthDropdown={false} 
                            showYearDropdown={false} 
                            minDate={props.minDate} 
                            maxDate={props.maxDate}
                            statusWiseRevenueDates={props.statusWiseRevenueDates}
                        />  : null
                    }
                </Col>
                <Col className="calendar-revenue-col-prev-next-date">
                    {
                        props.weeklyStartDate && props.weeklyEndDate ? 
                        <div className="weekly-revenue-calendar-dateFormat"><span>(DD/MM/YYYY)</span></div> : null
                    }
                </Col>
            </Row>
            <Row className="calendar-revenue-row">
                <Col className="calendar-revenue-col-calendar">
                    {
                        props.weeklyStartDate && props.weeklyEndDate ? 
                        <WeeklyDatePicker tabIndex={0}
                            inline
                            showPopperArrow={false}
                            enableTabLoop={true}
                            strictParsing={true}
                            dateFormat="dd/MM/yyyy" 
                            selectedDate={startDate}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange={true}
                            showMonthDropdown={true} 
                            showYearDropdown={true} 
                            dateChangeHandler={modifiedDate => dateChangeHandler(modifiedDate)}
                            minDate={props.minDate}
                            maxDate={props.maxDate}
                            statusWiseRevenueDates={props.statusWiseRevenueDates}
                        /> : null
                    }
                </Col>
            </Row>
        </Container>
    );
}
